import { predicates } from "../predicates";
import type { ObjectTypeConfig } from "../types";

export const CANVAS_NODE_ENTITY: ObjectTypeConfig = {
  actions: [
    {
      id: "chat-about",
      surfaces: ["floating-toolbar"],
      presentation: "toolbar-primary",
    },
    {
      id: "execute-action-item",
      surfaces: ["floating-toolbar"],
      presentation: "toolbar-primary",
      hiddenWhen: { not: { kind: { entityBase: "action-item" } } },
    },
    {
      id: "copy-url",
      surfaces: ["floating-toolbar", "context-menu", "pane-header"],
      presentation: {
        "floating-toolbar": "toolbar-utility",
        "context-menu": "menu-item",
        "pane-header": "icon-button",
      },
    },
    {
      id: "open",
      surfaces: ["floating-toolbar", "context-menu"],
      presentation: {
        "floating-toolbar": "toolbar-utility",
        "context-menu": "menu-item",
      },
      hiddenWhen: { not: { state: "hasDetailView" } },
    },
    {
      id: "open-in-new-tab",
      surfaces: ["floating-toolbar", "context-menu", "pane-header"],
      presentation: {
        "floating-toolbar": "toolbar-utility",
        "context-menu": "menu-item",
        "pane-header": "icon-button",
      },
      hiddenWhen: { not: { state: "hasWebLink" } },
    },
    // Hide is the non-destructive counterpart to delete: the node stays; the
    // surface just stops rendering it. Un-hiding lives on the canvas rail.
    {
      id: "remove-from-canvas",
      surfaces: ["context-menu"],
      presentation: "menu-item",
      hiddenWhen: { state: "hiddenOnCanvas" },
      disabledWhen: predicates.cannotEdit,
    },
    {
      id: "delete",
      surfaces: ["floating-toolbar", "context-menu"],
      presentation: {
        "floating-toolbar": "toolbar-primary",
        "context-menu": "menu-item",
      },
      disabledWhen: predicates.cannotEdit,
    },
    {
      id: "copy",
      surfaces: ["context-menu"],
      presentation: "menu-item",
      disabledWhen: predicates.copyDisabled,
    },
    {
      id: "bring-to-front",
      surfaces: ["context-menu", "floating-toolbar"],
      presentation: {
        "context-menu": "menu-item",
        "floating-toolbar": "toolbar-more-submenu",
      },
      disabledWhen: predicates.zOrderDisabled,
    },
    {
      id: "send-to-back",
      surfaces: ["context-menu", "floating-toolbar"],
      presentation: {
        "context-menu": "menu-item",
        "floating-toolbar": "toolbar-more-submenu",
      },
      disabledWhen: predicates.zOrderDisabled,
    },
  ],
};

/** Canvas entity nodes backed by a file record — extends the shared file-record config. */
export const CANVAS_NODE_ENTITY_FILE_RECORD: ObjectTypeConfig = {
  extends: "file-record",
  actions: [
    // Never star from a node menu. A file node is container-tier or a
    // reference by construction — never a favoritable Library file — but the
    // inherited star/unstar can't know that: their hiddenWhen speaks
    // file-record kind filters (class/isReference), and this surface resolves
    // with a canvas-node kind those filters don't match, so without this
    // override the actions render and the backend rejects the toggle.
    { id: "star", surfaces: [] },
    { id: "unstar", surfaces: [] },
    // A file node maps 1:1 to the file's canvas membership, so "delete" is the
    // real thing — remove the node AND trash the record (the file-record
    // handler layer does both). Override the inherited file-record delete so
    // it surfaces in the node context menu, gated on edit permission. The
    // non-destructive counterpart, Hide on canvas, is inherited from the
    // file-record config right above this entry.
    {
      id: "delete",
      surfaces: ["context-menu"],
      presentation: "menu-item",
      disabledWhen: predicates.cannotEdit,
    },
  ],
};
